<template>
	<div class="c-loading-dots">
		<div class="c-loading-dots__dot"></div>
		<div class="c-loading-dots__dot"></div>
		<div class="c-loading-dots__dot"></div>
	</div>
</template>

<script>
  export default {
		name: 'loading-dots',
		data: function () {
			return {

			}
		}
  }
</script>



// WEBPACK FOOTER //
// loading-dots.vue?9aabd2a8